import { Topping } from "@/shared/utils/interfaces";
import PricePerTarget from "../PricePerTarget";
import VatPerTarget from "../VatPerTarget";
import { Col, Row } from "react-grid-system";

interface Props {
  defaultValue: Topping;
  isShown: boolean;
}

const ToppingModalAdvance = ({ defaultValue, isShown }: Props) => {
  return (
    <Row style={{ display: isShown ? "block" : "none" }}>
      <Col xs={12}>
        <PricePerTarget data={defaultValue} />
      </Col>
      <Col xs={12}>
        <VatPerTarget data={defaultValue} />
      </Col>
    </Row>
  );
};

export default ToppingModalAdvance;
